var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.145,
    height: 14.717,
    viewBox: "0 0 14.145 14.717",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_231212",
    "data-name": "Group 231212",
    transform: "translate(-950.898 -632.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231211",
    "data-name": "Group 231211",
    transform: "translate(951.648 633.515)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M-21217.906-16166.331l6.5-3.238,6.146,3.238-6.146,2.928Z",
    transform: "translate(21217.906 16169.569)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M-21217.906-16157.643l6.5,2.928,2.277-1.1,3.869-1.832-6.146,2.928Z",
    transform: "translate(21217.906 16167.934)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    y2: 7.055,
    transform: "translate(0 3.275)",
    fill: "none",
    stroke: "#606060",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    y2: 7.055,
    transform: "translate(6.671 5.989)",
    fill: "none",
    stroke: "#606060",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    y2: 7.055,
    transform: "translate(12.639 3.275)",
    fill: "none",
    stroke: "#606060",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M-21185.113-16148.444l.139-1.262Z",
    transform: "translate(21197.316 16158.623)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DIcon);
export default __webpack_public_path__ + "static/media/3d-icon.33482fb6ef054da034d386f5b18e3322.svg";
export { ForwardRef as ReactComponent };